import {AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

import {CarrinhoService} from "../services/carrinho.service";
import {PedidoLoja} from "../objeto/PedidoLoja";
import {ProdutoService} from "../services/produto.service";
import {ITela} from "../objeto/ITela";
import {ConstantsService} from "../services/ConstantsService";
import {ClienteService} from "../services/cliente.service";
import {DominiosService} from "../services/dominios.service";
import {MyDetectorDevice} from "../app/shared/MyDetectorDevice";
import {
  DialogCloseResult,
  DialogRef,
  DialogService,
  WindowCloseResult,
  WindowRef,
  WindowService
} from "@progress/kendo-angular-dialog";
import {Location} from "@angular/common";
import {SiteProdutoComponent} from "../site-produto/site-produto.component";
import {SiteMontarpizzaComponent} from "../site-montarpizza/site-montarpizza.component";
import {AutorizacaoLojaService} from "../services/autorizacao-loja.service";
import {BannerService} from "../services/banner.service";
import {PopupUtils} from "../objeto/PopupUtils";
import {PopupEnderecoChinaInboxComponent} from "../app/popup-endereco-china-inbox/popup-endereco-china-inbox.component";
import {HttpClient} from "@angular/common/http";
import {catchError, map} from "rxjs/operators";
import {Observable, of, Subscription} from "rxjs";
import {SharedDataService} from "../services/shared.data.service";
import {FormaDeEntrega} from "../objeto/FormaDeEntrega";
import {Endereco} from "../objeto/Endereco";
import {SiteWizardProdutosIaComponent} from "../app/produtos/site-wizard-produtos-ia/site-wizard-produtos-ia.component";
import {ProdutosTelaUtils} from "./ProdutosTelaUtils";
import {PainelLoginComponent} from "../app/painel-login/painel-login.component";
import {ValidarContatoZapComponent} from "../app/cad-contato/validar-contato-zap/validar-contato-zap.component";
import {OpenpanelAnalyticsService} from "../services/openpanel-analytics.service";
import {DestaqueAberturaService} from "../services/destaque-abertura.service";
import {EstadoRodizioLoja} from "../objeto/EstadoRodizioLoja";

declare var _;
declare var $;

@Component({
  selector: 'app-produtos',
  templateUrl: './site-produtos.component.html',
  styleUrls: ['./site-produtos.component.scss' , './produtos-categorias.scss']
})
export class SiteProdutosComponent implements OnInit, ITela, AfterViewInit, OnDestroy {
  @ViewChild('divProdutos', {static: false}) divProdutos: any;
  @ViewChild('siteCategorias', {static: true}) siteCategorias: any;

  @ViewChild('megamenu', {static: false}) megamenu: ElementRef;
  @ViewChild('wraper', {static: false})   wraper: ElementRef;

  produtos = [];
  vitrines = [];
  ultimosPratos = [];
  carregou: boolean;
  mensagemErro = '';
  pedido: PedidoLoja;
  carregando: boolean;
  categorias: any  = [];
  produtosPorCategoria: any = {}
  nomePagina: string;
  isMobile: any;
  observer: IntersectionObserver;
  estaFazendoScroll: boolean;
  window: DialogRef;
  codigoProduto: any;
  idTamanho: any;
  idTamanhoVitrine: any;
  indiceProduto: any;
  codigopromo: any;
  hashMesa: string;
  mesaExpirada: boolean;
  layoutHorizontal: boolean;
  exibirMegaMenu: boolean
  larguraProdutos: number;
  empresa: any
  categoriasMegamenu: any;
  exibirVerMaisMegamenu = false;
  deslocamento = 0
  exibirMenuMobile = false;
  qtdeMaxima: number;
  movendo: boolean;
  categoriaMonteSuaPizza = {
    id: 1,  nome: ''
  };
  destaques =  [];
  nomeCategoriaDestaque = 'DESTAQUES';
  categoriaDestaque = {
    id: 2,
    nome: this.nomeCategoriaDestaque,
    imagem: null
  };
  alturaBanner = 230;

  banners = [];
  exibirPrecos = true;
  apiLoaded: Observable<boolean>;

  assinatura: Subscription;
  colunasMenu: any = {};
  evtEmpresa: Subscription;
  evtEmpresa2: Subscription;

  empresasDoGrupo = [];
  multiPedido = false;
  solicitandoGarcom: boolean;
  solicitandoFechar: boolean;
  mensagemSucessoGarcom: string;
  timerSolicitarGarcomNovamente: number;
   timerSolicitarFecharNovamente: number;

   ids = '';
  exibirMenuCategorias = false;
  evtCatalogo: any;
  categoriaSelecionada: any;
  exibirProdutosValorZerado = false;
  fidelidade: any;
  usuario: any;
  brindes: Array<any> = [];
  tabelaDePrecosCarregada: any = null;
  timerTabelaPrecos: any;
  exibirAvisoMesaAtiva = false;
  avisoMesaAtivaFechado = false;
  disparouEventoMenuOpen = false;
  destaqueAbertura: any;
  private destaqueAberturaAvaliado = false;
  private destaqueAberturaExibidoEm: number;
  private conteudoDestaque: any;
  private evtDestaqueSolicitado: any;
  private readonly limiteDiarioDestaque = 3;
  // sem intervalo, 3x/dia vira 3x seguidas em quem navega para a home e volta
  private readonly intervaloMinimoDestaqueMs = 30 * 60 * 1000;
  constructor(private router: Router, private sanitizer: DomSanitizer, private clienteService: ClienteService,
              private produtoService: ProdutoService, private carrinhoService: CarrinhoService,
              private autorizacaoLojaService: AutorizacaoLojaService, public sharedDataService: SharedDataService,
              private activatedRoute: ActivatedRoute, private constantsService: ConstantsService,
              private dominiosService: DominiosService, private detectorDevice: MyDetectorDevice,
              private dialogService: DialogService, private location: Location, private bannerService: BannerService,
              private httpClient: HttpClient, private autorizacao: AutorizacaoLojaService,
              private openpanelAnalyticsService: OpenpanelAnalyticsService,
              private destaqueAberturaService: DestaqueAberturaService) {
    this.nomePagina = dominiosService.obtenhaRaizCardapio();
    this.isMobile = this.detectorDevice.isMobile();


    this.hashMesa = this.activatedRoute.snapshot.params.hm;
    this.codigopromo = this.activatedRoute.snapshot.params.codigopromo;
    this.dominiosService.hashMesa = this.hashMesa

    document.body.classList.add("ativar_fundo_tema");

    if( this.isMobile ) {
      this.alturaBanner = 100;
    }

    if(window['multipedido']) {
      this.multiPedido = true;
      const  tipoCardapio = (this.hashMesa || (this.pedido && this.pedido.mesa )) ? 'MESA' : 'DELIVERY';

      this.produtoService.listeAhVendaGrupo(tipoCardapio, false).subscribe( (empresas: any) => {
        this.empresasDoGrupo = empresas;
      });
    }

    this.apiLoaded = this.httpClient.jsonp('https://maps.googleapis.com/maps/api/js?' +
      'key=AIzaSyBlPtg98e0hBo0JJSYMB3R7iakhFe_iT4o&callback=initMap&libraries=&v=weekly', 'callback').pipe(
      map(() => {
        console.log('chamando');
        return true
      }),
      catchError((error) => {
        console.log(error);
        return of(false);
      }),
    );



    this.inicializePedido().then(() => {
      this.activatedRoute.queryParams.subscribe(params => {

        if( params['ids'] ) {
          this.ids = params['ids'];
        }
        if( params['nl']  )
          this.autorizacaoLojaService.atualizeUsuarioLogado().then(  () => {
            if(params['target'])
              this.router.navigateByUrl(params['target']);
          });

        if( params['c'] ) {
          this.codigoProduto = parseInt(params['c'], 10);
          if( isNaN(this.codigoProduto) )
            this.codigoProduto = null;
        }

        if( params['t'] ) {
          this.idTamanho = parseInt(params['t'], 10);
          if( isNaN(this.idTamanho) )
            this.idTamanho = null;
        }
        if( params['tv'] ) {
          this.idTamanhoVitrine = parseInt(params['tv'], 10);
          if( isNaN(this.idTamanhoVitrine) )
            this.idTamanhoVitrine = null;
        }
        if( params['e'] ) {

          this.indiceProduto = parseInt(params['e'], 10);

          if( isNaN(this.indiceProduto) ) {
            this.indiceProduto = null;
          } else {
            this.indiceProduto = this.indiceProduto + '';
          }
        }
      });

      if (this.codigopromo)
        this.carrinhoService.atualizeValorDesconto(this.codigopromo, this.empresa, true).then( () => {});

      this.atualizeAvisoMesaAtiva();
    });

    this.sharedDataService.exibirMenu.subscribe(exibir => {
      this.exibirMenuMobile = exibir;
    });
  }

  public static abraPedindoEndereco(siteProdutos: SiteProdutosComponent, router: Router, location: Location, activatedRoute: ActivatedRoute,
                                    dialogService: DialogService, isMobile: boolean) {
    let dimensao = PopupUtils.calculeAlturaLarguraMenor(isMobile)

    const windowRef: DialogRef = dialogService.open({
      title: null,
      content: PopupEnderecoChinaInboxComponent,
      minWidth: 250,
      width: dimensao.largura,
      maxHeight: dimensao.altura,
      cssClass: 'bsModal'
    });

    let telaProduto: PopupEnderecoChinaInboxComponent = windowRef.content.instance;

    let params: any = {
    };

    telaProduto.window = windowRef;

    PopupUtils.abraJanela(router,  location, activatedRoute, windowRef, params);

    windowRef.result.subscribe((result: any) => {
      if( siteProdutos ) siteProdutos.exibirPrecos = true;
    });

    return windowRef;
  }

  ngAfterViewInit(): void {
    this.evtEmpresa2 = this.constantsService.empresa$.subscribe((empresa) => {
      if (!empresa)    return

      let params = this.activatedRoute.snapshot.params;

      this.empresa = empresa;
      this.openpanelAnalyticsService.init(empresa);
      const pedido: PedidoLoja = this.carrinhoService.obtenhaPedido();

      if (!this.disparouEventoMenuOpen) {
        this.disparouEventoMenuOpen = true;
        this.openpanelAnalyticsService.trackMenuOpen(empresa, pedido, {
          canal: this.obtenhaTipoCardapio() === 'MESA' ? 'mesa' : 'web'
        });
      }

      this.exibirMenuCategorias = empresa.cardapio && empresa.cardapio.exibirSelecaoCategorias;

      if( params.end ) {
        const endereco = Endereco.novo();
        Object.assign(endereco, JSON.parse(decodeURI(params.end)))

        this.pedido.entrega.formaDeEntrega = FormaDeEntrega.RECEBER_EM_CASA;
        this.pedido.entrega.setTaxaEntrega(endereco, null);
        this.carrinhoService.salvePedido(this.pedido);
      }

      const formaReceberEmCasa = this.obtenhaFormaDeEntregaReceberEmCasa(empresa);

      if (formaReceberEmCasa && formaReceberEmCasa.perguntarEnderecoInicio ) {
        if (!empresa.integracaoDelivery) {
          this.mensagemErro = 'Integração com Eclética tem que estar configurada';
        }

        if ((!pedido.entrega || !pedido.entrega.formaDeEntrega)) {
          this.exibirPrecos = false;
          SiteProdutosComponent.abraPedindoEndereco(this, this.router,
            this.location, this.activatedRoute, this.dialogService, this.isMobile);
        }
      }

      if (empresa.nomeCategoriaDestaques) {
        let nomeAnterior = this.categoriaDestaque.nome
        this.categoriaDestaque.nome = empresa.nomeCategoriaDestaques;
        this.categoriaDestaque.imagem = empresa.imagemCategoriaDestaque;
        this.produtosPorCategoria[this.categoriaDestaque.nome] = this.produtosPorCategoria[nomeAnterior]
      }

      this.bannerService.obtenhaBanners().then((banners) => {
        for (let i = 0; i < banners.length; i++) {
          const banner = banners[i];

          banner.thumbImage = banner.image = '/images/empresa/' + banner.linkImagem;
        }

        this.banners = banners;
      })

      this.layoutHorizontal = empresa.tipoDeLoja === 'MERCADO' || empresa.tipoDeLoja === 'ECOMMERCE';

      if (this.layoutHorizontal) {
        this.qtdeMaxima = 25;
      }

      if (this.layoutHorizontal) {
        if (this.isMobile) {
          this.larguraProdutos = ((this.divProdutos.nativeElement.clientWidth - 20) / 2);
        } else {
          this.larguraProdutos = ((this.divProdutos.nativeElement.clientWidth - 40) / 4);
        }
      }


      if( empresa.cardapio ) {
        const tipoDeCardapio = this.obtenhaTipoCardapio();

        this.exibirProdutosValorZerado = empresa.cardapio?.exibirProdutosValorZeradoMesa && tipoDeCardapio === 'MESA';
      }
    });
  }

  obtenhaFormaDeEntregaReceberEmCasa(empresa: any) {
    return empresa.formasDeEntrega.find( (forma) => {
      return forma.formaDeEntrega.nome === 'Receber em casa'
    });
  }

  ngOnDestroy(): void {
    if(this.evtEmpresa)
      this.evtEmpresa.unsubscribe();

    if(this.evtEmpresa2)
      this.evtEmpresa2.unsubscribe();

    if(this.evtCatalogo)
      this.evtCatalogo.unsubscribe();

    if(this.evtDestaqueSolicitado)
      this.evtDestaqueSolicitado.unsubscribe();

    // saindo do cardapio o atalho no topo perde o dono do modal
    this.destaqueAberturaService.publiqueDisponibilidade(false);

    this.pareMonitoramentoTabelaPrecos();
    document.body.classList.remove("ativar_fundo_tema");
  }

  @HostListener('window:focus')
  aoFocarJanela() {
    this.verifiqueTabelaPrecosCarregada();
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    if( this.window ) {
      let tela = this.window.content?.instance;

      if(tela && (tela.alterarQtde   || tela.alterarPeso)){
        tela.alterarQtde = tela.alterarPeso = false;
      } else {
        this.window.close({
          back: true
        });
      }
    }
  }

  /** Peças só do rodízio (cadastradas sem preço numa categoria coberta) ficam fora para quem não digitou o código. */
  categoriaSoDoRodizio(categoria: any): boolean {
    return EstadoRodizioLoja.categoriaSoDoRodizio(categoria, this.produtosPorCategoria && this.produtosPorCategoria[categoria.nome]);
  }

  private ordemDoRodizio: {categorias: any[], rodizio: any, lista: any[]} = null;

  /** Rodízio liberado: as seções incluídas sobem para o topo e o resto vem depois, sob "À parte". Fora dele, a ordem da loja. */
  get categoriasNaOrdem(): any[] {
    if (!EstadoRodizioLoja.ativo || !this.categorias || !this.categorias.length) return this.categorias;

    const cache = this.ordemDoRodizio;
    if (cache && cache.categorias === this.categorias && cache.rodizio === EstadoRodizioLoja.rodizio) return cache.lista;

    const incluidas = this.categorias.filter((categoria: any) => EstadoRodizioLoja.categoriaIncluida(categoria));
    const lista = incluidas.length ? incluidas.concat(this.categorias.filter((categoria: any) => !incluidas.includes(categoria)))
      : this.categorias;
    this.ordemDoRodizio = {categorias: this.categorias, rodizio: EstadoRodizioLoja.rodizio, lista};
    return lista;
  }

  /** Primeira seção visível de um grupo (incluído ou à parte) com o rodízio liberado: é onde entra o rótulo do grupo. */
  abreGrupoDoRodizio(categoria: any, incluido: boolean): boolean {
    if (!EstadoRodizioLoja.ativo || EstadoRodizioLoja.categoriaIncluida(categoria) !== incluido) return false;
    const primeira = (this.categoriasNaOrdem || []).find((outra: any) => !outra.ocultar && !this.categoriaSoDoRodizio(outra)
      && EstadoRodizioLoja.categoriaIncluida(outra) === incluido);
    return primeira === categoria && (incluido || (this.categoriasNaOrdem || []).some((outra: any) => EstadoRodizioLoja.categoriaIncluida(outra)));
  }

  /** "1 por pessoa · faltam 2": o limite da seção contando o que a mesa já pediu e o que está na rodada. */
  limiteDaSecao(categoria: any): string {
    const rodizio = EstadoRodizioLoja.rodizio;
    if (!EstadoRodizioLoja.ativo || !rodizio || !categoria) return null;
    const regra = (rodizio.categorias || []).find((outra: any) => Number(outra.id) === Number(categoria.id));
    const maximo = Number(regra && regra.maximoPorPessoa) || 0;
    const pessoas = Number(rodizio.plano && rodizio.plano.pessoas) || 0;
    if (!maximo || !pessoas) return null;

    const naRodada = ((this.pedido && this.pedido.itens) || [])
      .filter((item: any) => EstadoRodizioLoja.produtoIncluido(item.produto)
        && EstadoRodizioLoja.categoriaDoProduto(item.produto) === Number(categoria.id))
      .reduce((soma: number, item: any) => soma + (Number(item.qtde) || 0), 0);
    const faltam = Math.max(0, maximo * pessoas - (Number(regra.jaPedidos) || 0) - naRodada);
    return `${maximo} por pessoa · ${faltam ? 'faltam ' + faltam : 'mesa completa'}`;
  }

  abraDetalhesProduto(produto: any, indiceProduto: any = null) {
    if(produto.naodisponivel) return;

    if(this.deveUsarModoCaptacaoLead())
      return this.abrirInteresseProduto(produto);

    if(!produto.montar){
      this.window = SiteProdutoComponent.abraComoPopup(this.router, this.location, this.activatedRoute,
        this.dialogService, this.isMobile, produto, indiceProduto , null , () => {
          this.setSaldoDisponivel();
        });
    } else {
      this.window =  SiteMontarpizzaComponent.abraComoPopup(this.router, this.location, this.activatedRoute,
        this.dialogService, this.isMobile, produto, indiceProduto);
    }
  }

  deveUsarModoCaptacaoLead(empresa: any = this.empresa): boolean {
    return !!empresa?.cardapio?.modoCaptacaoLead;
  }

  deveRedirecionarParaCadastroAntesDaVitrine(empresa: any = this.empresa): boolean {
    return !!(empresa?.cardapio?.exigeCadastro && !this.deveUsarModoCaptacaoLead(empresa) && !this.usuario);
  }

  abrirInteresseProduto(produto: any) {
    if(this.usuario?.telefone)
      return this.abraWhatsappInteresseProduto(produto, this.usuario.nome);

    const urlCliente = this.dominiosService.obtenhaUrlCompleta('cliente');

    this.router.navigateByUrl(
      urlCliente + '?lead=1&idProduto=' + produto.id + '&produto=' + encodeURIComponent(produto.nome || '')
    );
  }

  abraWhatsappInteresseProduto(produto: any, nome: string = null) {
    const numero = this.obtenhaNumeroWhatsappCaptacao();
    if(!numero) return;

    window.open('https://wa.me/' + numero + '?text=' + encodeURIComponent(this.monteMensagemInteresseProduto(produto, nome)), '_blank');
  }

  monteMensagemInteresseProduto(produto: any, nome: string = null): string {
    let mensagem = 'Olá! Tenho interesse em saber mais sobre ' + (produto.nome || 'esse serviço') + '.';
    if(nome)
      mensagem += ' Meu nome é ' + nome + '.';

    return mensagem;
  }

  obtenhaNumeroWhatsappCaptacao(): string {
    let numero = String(this.empresa?.numeroWhatsapp?.whatsapp || this.empresa?.whatsapp || '').replace(/\D/g, '');
    if(numero && numero.length <= 11)
      numero = '55' + numero;

    return numero;
  }

  abraDetalhesPrato(itemPedido: any){
    this.window = SiteProdutoComponent.abraComoPopup(this.router, this.location, this.activatedRoute,
      this.dialogService, this.isMobile, itemPedido.produto, null, itemPedido);
  }

  obtenhaTipoCardapio(){
    const fluxoMesa = this.hashMesa || this.pedido?.mesa ||
      (!window['multipedido'] && this.pedido?.tokenCartaoPendente);

    return fluxoMesa ? 'MESA' : 'DELIVERY' ;
  }

  carregueCategoriasDepoisProdutos(){

   this.evtCatalogo =
     this.constantsService.obtenhaCarpadioCompleto( this.obtenhaTipoCardapio(), this.empresa).subscribe(async (cardapio: any) => {
      if(!cardapio) return;

      if(cardapio.categorias){
        this.categorias = cardapio.categorias;
        this.carregando = false;
      }

      if(cardapio.produtos){
        this.produtos = cardapio.produtos;
        if(cardapio.recarregouPorTabela)
          this.limpePagamentoPorTrocaTabela();
        await this.atualizeVitrines();
        this.agrupePorCategorias();
        this.avalieDestaqueAbertura(this.empresa);
        this.setBrindesDisponiveis(cardapio.brindes);
        this.reapliqueProdutosNoCarrinho(cardapio.produtos);
      }

    })
  }


  agrupePorCategorias(){
    this.produtosPorCategoria = _.groupBy(this.produtos, produto => produto.categoria ? produto.categoria?.nome?.trim() : 'Outros');

    ProdutosTelaUtils.definaCategoriasFixas(this);
  }

  private reapliqueProdutosNoCarrinho(produtosAtuais: any[]) {
    if(!this.pedido?.itens?.length || !produtosAtuais?.length)
      return;

    let alterou = false;

    this.pedido.itens.forEach((item: any) => {
      const produtoAtual = item.produto?.vitrineProdutoTamanhoId ?
        this.obtenhaProdutoDaVitrine(item.produto.id, item.produto.vitrineProdutoTamanhoId) :
        produtosAtuais.find((produto: any) => Number(produto.id) === Number(item.produto?.id));
      if(!produtoAtual)
        return;

      // o produto da listagem vem sem empresa; sem ela a reidratação do carrinho
      // (calculeItensPorEmpresa) estoura na próxima abertura da loja
      if(!produtoAtual.empresa && item.produto?.empresa)
        produtoAtual.empresa = item.produto.empresa;
      item.produto = produtoAtual;
      if(item.produtoTamanho)
        item.produtoTamanho = this.obtenhaProdutoTamanhoAtual(produtoAtual, item.produtoTamanho);

      this.reapliqueSaboresDaListagemNoItem(item, produtosAtuais);
      this.reapliqueAdicionaisDaListagemNoItem(item);
      item.atualizeTotal();
      alterou = true;
    });

    if(alterou) {
      this.pedido.calculeTotal();
      this.carrinhoService.salvePedido(this.pedido);
    }
  }

  private reapliqueSaboresDaListagemNoItem(item: any, produtosAtuais: any[]) {
    if(!item?.sabores?.length)
      return;

    item.sabores.forEach((sabor: any) => {
      const idProdutoSabor = Number(sabor.produto?.id || sabor.produto || 0);
      const produtoSaborAtual = produtosAtuais.find((produto: any) => Number(produto.id) === idProdutoSabor);
      if(!produtoSaborAtual)
        return;

      const tamanhoAtual = this.obtenhaProdutoTamanhoAtual(
        produtoSaborAtual,
        item.produtoTamanho || sabor.produtoTamanho
      );

      sabor.produto = produtoSaborAtual.id;
      sabor.nome = produtoSaborAtual.nome;
      sabor.descricao = produtoSaborAtual.descricao;
      sabor.produtoTamanho = tamanhoAtual;
      sabor.preco = Number(tamanhoAtual?.preco || 0);
    });
  }

  private reapliqueAdicionaisDaListagemNoItem(item: any) {
    if(!item?.adicionais || !item?.produto)
      return;

    const opcoesPorId = this.monteOpcoesAdicionaisPorId(item.produto);
    if(!opcoesPorId.size)
      return;

    this.atualizeOpcoesAdicionais(item.adicionais, opcoesPorId);
  }

  private monteOpcoesAdicionaisPorId(produto: any): Map<number, any> {
    const opcoesPorId = new Map<number, any>();
    const coleteOpcoes = (campos: any[] = []) => {
      campos.forEach((campo: any) => {
        (campo.opcoesDisponiveis || []).forEach((opcao: any) => {
          if(opcao?.id)
            opcoesPorId.set(Number(opcao.id), opcao);
        });
      });
    };

    coleteOpcoes(produto.camposAdicionais || []);
    (produto.tamanhos || []).forEach((tamanho: any) => coleteOpcoes(tamanho.camposAdicionais || []));

    return opcoesPorId;
  }

  private atualizeOpcoesAdicionais(alvo: any, opcoesPorId: Map<number, any>, profundidade = 0) {
    if(!alvo || profundidade > 6 || typeof alvo !== 'object')
      return;

    Object.keys(alvo).forEach((prop: string) => {
      const valor = alvo[prop];
      if(!valor || typeof valor !== 'object')
        return;

      const idOpcao = Number(valor?.opcao?.id || valor?.id || 0);
      const opcaoAtual = opcoesPorId.get(idOpcao);

      if(opcaoAtual) {
        if(valor.opcao)
          valor.opcao = opcaoAtual;
        else
          alvo[prop] = opcaoAtual;
      } else {
        this.atualizeOpcoesAdicionais(valor, opcoesPorId, profundidade + 1);
      }
    });
  }

  private obtenhaProdutoTamanhoAtual(produto: any, produtoTamanho: any): any {
    if(!produtoTamanho || !produto?.tamanhos?.length)
      return produtoTamanho;

    return produto.tamanhos.find((tamanho: any) => {
      if(tamanho.id && produtoTamanho.id && Number(tamanho.id) === Number(produtoTamanho.id))
        return true;

      return tamanho.template?.id && produtoTamanho.template?.id &&
        Number(tamanho.template.id) === Number(produtoTamanho.template.id);
    }) || produtoTamanho;
  }

  carregouProdutos(abrirProdutoDaUrl = true){
    this.produtos.forEach((produto: any) => {
      if( produto.tags.length &&  !produto.tags[0].nome){
        for(let i = 0 ; i <  produto.tags.length ; i++)
          produto.tags[i] =  this.empresa.tagsProdutos.find((item: any) => item.id ===  produto.tags[i].id)

      }

    })
    if(this.ids) {
      let dimensao = PopupUtils.calculeAlturaLargura(this.isMobile);

      const windowRef: DialogRef = this.dialogService.open({
        title: null,
        content: SiteWizardProdutosIaComponent,
        minWidth: 250,
        width: dimensao.largura,
        height: dimensao.altura
      });

      let telaProduto: SiteWizardProdutosIaComponent = windowRef.content.instance;
      telaProduto.ids = this.ids;
      telaProduto.categorias = this.categorias;
      telaProduto.produtos = this.produtos;
      telaProduto.window = windowRef;

      telaProduto.processe();

      PopupUtils.abraJanela(this.router, this.location, this.activatedRoute,
        windowRef, {}, null, 'dialog-produto-ia');

    }

    this.atualizeCatalogoDeSaboresComVitrines();

    if( this.layoutHorizontal ) {
      for (let i = 0; i < this.produtos.length; i++) {
        const produto = this.produtos[i];
        produto.destacado = true;
      }
    }

    this.agrupePorCategorias();

    this.categoriaSelecionada =  this.categorias.length ? this.categorias[0].nome : '';

    this.carregando = false;

    this.avalieDestaqueAbertura(this.empresa);

    if(abrirProdutoDaUrl && this.codigoProduto ) {
      const produto = this.obtenhaProduto(this.codigoProduto);
      if(produto)
        this.abraDetalhesProduto(produto, this.indiceProduto);
    } else if (abrirProdutoDaUrl && this.idTamanho){
      let produtoCategoria =
        this.produtosPorCategoria[this.categoriaMonteSuaPizza.nome].find( produtoCategogia => produtoCategogia.id === this.idTamanho);

      this.abraDetalhesProduto(produtoCategoria, this.indiceProduto);
    }

    this.assinatura = this.activatedRoute.params.subscribe( (params2) => {
      const idCategoria = params2.idc;

      if(idCategoria){
        const categoria = this.categorias.find((cat: any) => cat.id === Number(idCategoria))

        if( categoria ) {
          setTimeout( () => {
            this.selecionou(categoria);
            this.assinatura.unsubscribe();
          }, 1000);
        }
      }
    });

  }

  ngOnInit() {
    this.carregando = true;

    this.evtDestaqueSolicitado = this.destaqueAberturaService.aberturaSolicitada$.subscribe(
      (origem) => this.abraDestaquePorSolicitacao(origem));
    this.autorizacao.usuario$.subscribe( (usuario) => {
      this.usuario = null
      if(usuario && usuario.id)
        this.usuario = usuario;

      this.setSaldoDisponivel();

    });

    this.evtEmpresa = this.constantsService.empresa$.subscribe( (empresa) => {
      if( !empresa ) { return }

      if(this.deveRedirecionarParaCadastroAntesDaVitrine(empresa))
         return this.dominiosService.vaParaLogin(null, null, true);

      this.exibirMegaMenu = empresa.tipoDeLoja === 'ECOMMERCE';
      this.layoutHorizontal = empresa.tipoDeLoja === 'MERCADO' || empresa.tipoDeLoja === 'ECOMMERCE';

      if(  this.exibirMegaMenu ){
        this.produtoService.listeCategoriasMegamenu().then( (categoriasMegamenu) => {
          this.categoriasMegamenu = categoriasMegamenu;
          this.setColunasMegaMenu();
        }).catch(erro => {
          console.log(erro)
        })
      }

      this.atualizeVitrines().then(() => {
        if(this.vitrines.length &&  this.exibirMegaMenu ) {
          this.carregando = false;
          ProdutosTelaUtils.definaCategoriasFixas(this);
          this.avalieDestaqueAbertura(empresa);
          if(this.codigoProduto) {
            const produto = this.obtenhaProduto(this.codigoProduto);
            if(produto)
              this.abraDetalhesProduto(produto, this.indiceProduto);
          }
          return;
        }

        const  tipoCardapio =  this.obtenhaTipoCardapio();

        if(window.history.state.fezLogin)
          this.produtoService.removaDaCache(empresa, tipoCardapio);

        this.ultimosPratos = [];

        if(this.exibirMenuCategorias)  {
          this.carregueCategoriasDepoisProdutos();
          return;
        }

        this.produtoService.listeAhVenda(empresa, tipoCardapio, this.layoutHorizontal).subscribe( (resposta: any) => {
          this.produtos = resposta.produtos;
          this.categorias = resposta.categorias;
          this.atualizeTabelaDePrecosCarregada(resposta.tabelaDePrecosCarregada || null);
          if(resposta.ultimosPratos){
            resposta.ultimosPratos.forEach((itemPedido: any) => {
              //  produtoPedirNovamente.destacado = true;
              this.ultimosPratos.push(itemPedido);
            })
          }
          this.carregouProdutos();
          this.setBrindesDisponiveis(resposta.brindes );
          this.reapliqueProdutosNoCarrinho(resposta.produtos);
        });
      });
    });
  }

  private atualizeTabelaDePrecosCarregada(tabela: any) {
    const tabelaAnteriorId = this.tabelaDePrecosCarregada?.id;
    const tabelaAnteriorData = this.normalizeDataTabelaPrecos(this.tabelaDePrecosCarregada?.dataUltimaAtualizacao);

    this.tabelaDePrecosCarregada = tabela || null;

    if(!this.tabelaDePrecosCarregada?.id) {
      this.pareMonitoramentoTabelaPrecos();
      return;
    }

    const mudouTabela = Number(tabelaAnteriorId) !== Number(this.tabelaDePrecosCarregada.id);
    const mudouData = tabelaAnteriorData !== this.normalizeDataTabelaPrecos(this.tabelaDePrecosCarregada.dataUltimaAtualizacao);

    if(!this.timerTabelaPrecos || mudouTabela || mudouData)
      this.inicieMonitoramentoTabelaPrecos();
  }

  private inicieMonitoramentoTabelaPrecos() {
    this.pareMonitoramentoTabelaPrecos();
    this.timerTabelaPrecos = setInterval(() => this.verifiqueTabelaPrecosCarregada(), 60000);
  }

  private pareMonitoramentoTabelaPrecos() {
    if(this.timerTabelaPrecos) {
      clearInterval(this.timerTabelaPrecos);
      this.timerTabelaPrecos = null;
    }
  }

  private verifiqueTabelaPrecosCarregada() {
    if(this.carregando || !this.tabelaDePrecosCarregada?.id || !this.empresa)
      return;

    const tabelaCarregada = this.tabelaDePrecosCarregada;
    this.produtoService.obtenhaStatusTabelaPrecosCarregada(tabelaCarregada.id, this.obtenhaTipoCardapio())
      .then((status: any) => {
        if(!this.tabelaDePrecosCarregada || Number(this.tabelaDePrecosCarregada.id) !== Number(tabelaCarregada.id))
          return;

        const dataAtual = this.normalizeDataTabelaPrecos(status?.dataUltimaAtualizacao);
        const dataCarregada = this.normalizeDataTabelaPrecos(tabelaCarregada.dataUltimaAtualizacao);
        const tabelaAtualId = Number(status?.tabelaAtual?.id || 0);

        if(!status?.disponivel || dataAtual !== dataCarregada ||
          (tabelaAtualId && tabelaAtualId !== Number(tabelaCarregada.id)))
          this.recarregueProdutosPorTabela();
      })
      .catch((erro) => console.error('Erro ao verificar tabela de precos carregada', erro));
  }

  private recarregueProdutosPorTabela() {
    const tipoCardapio = this.obtenhaTipoCardapio();

    this.carregando = true;
    this.produtoService.removaDaCache(this.empresa, tipoCardapio);
    this.produtoService.listeAhVenda(this.empresa, tipoCardapio, this.layoutHorizontal).subscribe(async (resposta: any) => {
      this.produtos = resposta.produtos;
      this.categorias = resposta.categorias;
      this.limpePagamentoPorTrocaTabela();
      this.atualizeTabelaDePrecosCarregada(resposta.tabelaDePrecosCarregada || null);
      await this.atualizeVitrines();
      this.carregouProdutos(false);
      this.setBrindesDisponiveis(resposta.brindes);
      this.reapliqueProdutosNoCarrinho(resposta.produtos);
    });
  }

  private async atualizeVitrines(): Promise<void> {
    try {
      const resposta: any = await this.produtoService.listeProdutosVitrine(
        true,
        this.obtenhaTipoCardapio(),
        this.tabelaDePrecosCarregada?.id || null
      );
      this.vitrines = Array.isArray(resposta) ? resposta : (resposta?.vitrines || []);
      this.atualizeCatalogoDeSaboresComVitrines();

      if(!Array.isArray(resposta) && resposta?.tabelaDePrecosCarregada)
        this.atualizeTabelaDePrecosCarregada(resposta.tabelaDePrecosCarregada);
    } catch (erro) {
      console.error('Erro ao recarregar vitrines', erro);
    }
  }

  private limpePagamentoPorTrocaTabela(): void {
    if(!this.pedido)
      this.pedido = this.carrinhoService.obtenhaPedido();

    if(!this.pedido)
      return;

    this.pedido.removaPagamentoSelecionado();
    this.pedido.calculeTotal();
    this.carrinhoService.salvePedido(this.pedido);
  }

  private normalizeDataTabelaPrecos(data: any): string {
    return data ? String(data) : '';
  }

 async setBrindesDisponiveis(brindes: any){
    if(this.isMobile || !brindes) return;
   if(this.empresa.integracaoPedidoFidelidade && this.empresa.integracaoPedidoFidelidade.resgatarBrinde){
     this.brindes = brindes.sort((a: any, b: any) =>  a.valorResgate - b.valorResgate);

     await this.setSaldoDisponivel();
   }
  }

  private async setSaldoDisponivel() {
    if(this.isMobile || !this.empresa || !this.empresa.exibirFidelidade || this.pedido.estaEmFluxoMesa()) return;

    if(this.usuario)
      await this.autorizacao.atualizeSaldoFidelidade(this.usuario);

    let tipoAcumulo = '', pontuando = true, cashback = null;

    if(this.empresa.integracaoPedidoFidelidade){
      tipoAcumulo =  this.empresa.integracaoPedidoFidelidade.plano.tipoDeAcumulo
      pontuando = this.empresa.integracaoPedidoFidelidade.pontuando
      if(tipoAcumulo === 'Reais')
        cashback  = this.empresa.integracaoPedidoFidelidade.atividade.cashback * 100;
    }

    this.fidelidade  = { descricao: this.empresa.integracaoPedidoFidelidade.plano.nome,
      saldoDisponivel:   this.usuario ? this.usuario.saldoFidelidade : 0,
      pontuando: pontuando,
      cashback: cashback,
      acumulo: tipoAcumulo === 'Selos' ? 'selos' : 'pts'
    }

    if(!this.usuario || this.usuario.fezLoginGuest) this.fidelidade.fazerLogin = true;

    if(this.fidelidade){
      this.fidelidade.saldoDisponivel = (this.usuario ? this.usuario.saldoFidelidade : 0) - this.pedido.totalResgatado;
      if(this.fidelidade.saldoDisponivel < 0)
        this.fidelidade.saldoDisponivel = 0

      this.brindes.forEach((item: any) => {
        item.naodisponivel =    item.valorResgate > this.fidelidade.saldoDisponivel;
        item.acumulo = this.fidelidade.acumulo
      })
    }

  }

  obtenhaProduto(id: number) {
    if(this.idTamanhoVitrine) {
      const produtoVitrine = this.obtenhaProdutoDaVitrine(id, this.idTamanhoVitrine);
      if(produtoVitrine) return produtoVitrine;
    }

    return this.produtos.find(produto => Number(produto.id) === Number(id)) ||
      this.brindes.find(brinde => Number(brinde.id) === Number(id)) ||
      this.obtenhaProdutoDaVitrine(id);
  }

  private obtenhaProdutoDaVitrine(idProduto: number, idProdutoTamanho: number = null): any {
    for(const vitrine of this.vitrines || []) {
      const produtoNaVitrine = (vitrine.produtosNaVitrine || []).find((item: any) => {
        if(Number(item.produto?.id) !== Number(idProduto))
          return false;

        return !idProdutoTamanho ||
          Number(item.idProdutoTamanho) === Number(idProdutoTamanho);
      });

      if(produtoNaVitrine)
        return produtoNaVitrine.produto;
    }

    return null;
  }

  // Destaque na abertura: suprimido em deep-link de produto, carrinho em andamento
  // e fluxos de aviso de mesa. Capping de 3x/dia por loja no localStorage, com 30min
  // entre uma e outra — sem isso, voltar para a home reabre o modal, porque
  // destaqueAberturaAvaliado e de instancia e morre junto com o componente.
  // Use ?destaque=1 para forcar em teste.
  // Fonte automatica: produtos em promocao (destaque); vitrine quando configurada.
  private avalieDestaqueAbertura(empresa: any) {
    if(!empresa || this.destaqueAberturaAvaliado) return;
    this.destaqueAberturaAvaliado = true;

    if(empresa.cardapio && empresa.cardapio.exibirDestaqueAbertura === false) return;
    if(!this.estaNoCardapioPrincipal()) return;

    const conteudo = this.obtenhaConteudoDestaqueAbertura(empresa);

    if(!conteudo || !conteudo.produtos.length) return;

    // o atalho no topo do desktop continua valendo mesmo quando a abertura
    // automatica e suprimida: quem clica no item esta pedindo para ver
    this.conteudoDestaque = conteudo;
    this.destaqueAberturaService.publiqueDisponibilidade(true);

    if(this.mesaExpirada || this.exibirAvisoMesaAtiva) return;
    if(this.pedido && this.pedido.itens && this.pedido.itens.length) return;

    const queryParams = this.activatedRoute.snapshot.queryParams || {};
    if(queryParams['c'] || queryParams['t'] || queryParams['ids']) return;

    if(String(queryParams['destaque'] || '') !== '1' && !this.podeExibirDestaque(empresa)) return;

    this.marqueDestaqueExibidoHoje(empresa);
    this.exibaDestaqueAbertura(conteudo, empresa, 'automatico');
  }

  // pedido pelo cliente (item no topo): nao gasta cota nem respeita o intervalo
  private abraDestaquePorSolicitacao(origem = 'topo') {
    if(!this.conteudoDestaque || this.destaqueAbertura) return;

    this.exibaDestaqueAbertura(this.conteudoDestaque, this.empresa, origem);
  }

  private exibaDestaqueAbertura(conteudo: any, empresa: any, origem: string) {
    this.destaqueAbertura = conteudo;
    this.destaqueAberturaExibidoEm = new Date().getTime();

    this.openpanelAnalyticsService.track('promo_sheet_view', {
      fonte: conteudo.fonte,
      vitrineId: conteudo.vitrineId,
      nome: conteudo.nome,
      qtdeProdutos: conteudo.produtos.length,
      formato: (empresa && empresa.cardapio && empresa.cardapio.formatoDestaqueAbertura) || 'SHEET',
      tipoCardapio: this.obtenhaTipoCardapio(),
      origem: origem
    });
  }

  private chaveDestaqueAbertura(empresa: any) {
    return 'destaque_abertura_' + (empresa && empresa.id || '');
  }

  // dia local, nao UTC: com toISOString o capping viraria as 21h no horario de Brasilia
  private diaDeHojeDoDestaque() {
    const agora = new Date();

    return agora.getFullYear() + '-' + (agora.getMonth() + 1) + '-' + agora.getDate();
  }

  // guardado como "dia|vezes|ultimaEm"; dia diferente zera a contagem.
  // localStorage estoura em aba anonima/modo restrito: sem storage o modal volta a
  // aparecer, o que e melhor do que derrubar a abertura do cardapio
  private estadoDestaqueDoDia(empresa: any) {
    try {
      const partes = String(localStorage.getItem(this.chaveDestaqueAbertura(empresa)) || '').split('|');

      if(partes[0] !== this.diaDeHojeDoDestaque()) return {vezes: 0, ultimaEm: 0};

      return {vezes: Number(partes[1]) || 0, ultimaEm: Number(partes[2]) || 0};
    } catch(erro) {
      return {vezes: 0, ultimaEm: 0};
    }
  }

  private podeExibirDestaque(empresa: any) {
    const estado = this.estadoDestaqueDoDia(empresa);

    if(estado.vezes >= this.limiteDiarioDestaque) return false;

    return new Date().getTime() - estado.ultimaEm >= this.intervaloMinimoDestaqueMs;
  }

  private marqueDestaqueExibidoHoje(empresa: any) {
    const estado = this.estadoDestaqueDoDia(empresa);

    try {
      localStorage.setItem(this.chaveDestaqueAbertura(empresa),
        [this.diaDeHojeDoDestaque(), estado.vezes + 1, new Date().getTime()].join('|'));
    } catch(erro) {
    }
  }

  private obtenhaConteudoDestaqueAbertura(empresa: any) {
    const idVitrineConfigurada = empresa.cardapio ? empresa.cardapio.vitrineAberturaId : null;

    // vitrine escolhida pelo lojista: sem fallback surpresa se estiver vazia/indisponivel
    if(idVitrineConfigurada) {
      const vitrine = (this.vitrines || []).find(
        (item: any) => Number(item.id) === Number(idVitrineConfigurada));

      return vitrine ? this.monteConteudoDaVitrine(vitrine) : null;
    }

    const destaques = (this.destaques || []).filter(
      (produto: any) => produto && !produto.indisponivel && !produto.naodisponivel);

    if(destaques.length)
      return {
        fonte: 'destaques',
        nome: this.categoriaDestaque.nome,
        imagem: this.categoriaDestaque.imagem,
        vitrineId: null,
        categoriaId: this.categoriaDestaque.id,
        produtos: destaques
      };

    const vitrineComProdutos = (this.vitrines || []).find(
      (item: any) => item.produtosNaVitrine && item.produtosNaVitrine.length);

    return vitrineComProdutos ? this.monteConteudoDaVitrine(vitrineComProdutos) : null;
  }

  private monteConteudoDaVitrine(vitrine: any) {
    const produtos = (vitrine.produtosNaVitrine || [])
      .map((produtoNaVitrine: any) => produtoNaVitrine.produto)
      .filter((produto: any) => produto && !produto.indisponivel);

    return {
      fonte: 'vitrine',
      nome: vitrine.nome,
      imagem: vitrine.imagem,
      vitrineId: vitrine.id,
      categoriaId: vitrine.id,
      produtos: produtos
    };
  }

  abriuProdutoDoDestaque(produto: any) {
    this.openpanelAnalyticsService.track('promo_sheet_product_click', {
      fonte: this.destaqueAbertura ? this.destaqueAbertura.fonte : null,
      vitrineId: this.destaqueAbertura ? this.destaqueAbertura.vitrineId : null,
      productId: produto.id,
      productName: produto.nome
    });

    this.abraDetalhesProduto(produto);
  }

  verTodosDoDestaque() {
    const conteudo = this.destaqueAbertura;

    this.openpanelAnalyticsService.track('promo_sheet_see_all', {
      fonte: conteudo ? conteudo.fonte : null,
      vitrineId: conteudo ? conteudo.vitrineId : null
    });

    if(!conteudo) return;

    const categoria = this.categorias.find((item: any) => {
      if(Number(item.id) !== Number(conteudo.categoriaId)) return false;

      return conteudo.fonte === 'vitrine' ? !!item.vitrine : !item.vitrine;
    });

    if(categoria)
      setTimeout(() => this.selecionou(categoria), 250);
  }

  fechouDestaqueAbertura(origem: string) {
    if(origem !== 'produto' && origem !== 'ver_todos') {
      this.openpanelAnalyticsService.track('promo_sheet_dismiss', {
        fonte: this.destaqueAbertura ? this.destaqueAbertura.fonte : null,
        vitrineId: this.destaqueAbertura ? this.destaqueAbertura.vitrineId : null,
        origem: origem,
        tempoExibidoMs: this.destaqueAberturaExibidoEm ?
          new Date().getTime() - this.destaqueAberturaExibidoEm : null
      });
    }

    this.destaqueAbertura = null;
  }

  private atualizeCatalogoDeSaboresComVitrines(): void {
    const produtosPorId = new Map<number, any>();

    (this.constantsService.produtosLoja || []).forEach(
      (produto: any) => produtosPorId.set(Number(produto.id), produto)
    );
    (this.produtos || []).forEach(
      (produto: any) => produtosPorId.set(Number(produto.id), produto)
    );

    for(const vitrine of this.vitrines || []) {
      for(const produtoNaVitrine of vitrine.produtosNaVitrine || []) {
        const produto = produtoNaVitrine.produto;
        if(!produtosPorId.has(Number(produto.id)))
          produtosPorId.set(Number(produto.id), produto);
      }
    }

    this.constantsService.produtosLoja = Array.from(produtosPorId.values());
  }

  getPosicao(nomeCategoria){
    let _produto = this.produtos.find( produto => produto.categoria && produto.categoria.nome.trim() === nomeCategoria.trim())

    let posicao = _produto ? _produto.categoria.posicao : this.produtos.length;

    return posicao;
  }

  deveExibirTopo() {
    return true;
  }

  deveExibirMenu(){
    return true;
  }

  abraTelaDeBusca() {
    const params: any = {state: {ehMesa: (this.hashMesa || this.pedido?.estaEmFluxoMesa())}};

    let link = String(`/${this.nomePagina}/busca`);

    if(this.empresa.layoutEcommerce){
      link += '/ecommerce/todos'
      params.state.categorias = this.categoriasMegamenu;
    }

    this.router.navigateByUrl(link, {}).then( () => { });
  }

  abraTelaBuscaCategoria(categoria: any) {
    this.sharedDataService.exibirMenuMobile = false;

    this.router.navigateByUrl('/busca/ecommerce/' + categoria.id,
      {state: { categoria: categoria, categorias: this.categoriasMegamenu }  });

    return false;
  }

  abraTelaBuscaPorCategoria(categoria) {
    if(this.empresa && this.empresa.layoutEcommerce){
      this.abraTelaBuscaCategoria(categoria)
    } else {
      const produtos = this.produtosPorCategoria[categoria.nome];
      const mapProdutosPorCategoria = {};

      mapProdutosPorCategoria[categoria.nome] = produtos;

      const state = {state: {produtos: produtos,
          produtosPorCategoria: mapProdutosPorCategoria, categorias: [categoria],
          ehMesa: (this.hashMesa || this.pedido?.estaEmFluxoMesa())}};

      this.router.navigateByUrl('/busca?cid=' + categoria.id, state).then( () => {});
    }

    return false;
  }

  voltar() {

  }


  getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left + window.scrollX,
      top: rect.top + window.scrollY
    };
  }


  exibaProdutosCategoria(categoria: any){

  }

  selecionou(categoria) {
    this.categoriaSelecionada = categoria.nome;

    const idTab = 'tab_' + categoria.nome;
    const nomeCategoria = categoria.nome;

    this.posicioneTab(idTab);

    this.posicioneConteudo(nomeCategoria);

    let novaUrl = '/categoria/' +
      categoria.nome.toLowerCase().replace(/\s+/g, "-") + '/' + categoria.id + window.location.search;

    this.openpanelAnalyticsService.trackCategoryView(categoria, {
      categoryPath: novaUrl,
      tipoCardapio: this.obtenhaTipoCardapio()
    });

    // this.location.replaceState(novaUrl);
    window.history.pushState({path: novaUrl}, '', novaUrl);

    return false;
  }

  posicioneTab(categoria) {
    categoria = categoria.trim();
    const tab = document.getElementById(categoria);

    if(tab){
      const $tabs = $("#tabs.nav-tabs");
      const posicao = tab.offsetLeft - ($tabs.width() / 2) + (tab.getBoundingClientRect().width / 2);

      $tabs.animate({scrollLeft: posicao}, 100);
    }

  }

  @HostListener('window:scroll', ['$event']) onScrollEvent($event){
    if( this.estaFazendoScroll ) {
      return;
    }

    const tabs = document.querySelectorAll('.categoria');

    for( let i = tabs.length - 1; i >= 0; i-- ) {
      const tab: any = tabs[i];

      const topElemento = this.getOffset(tab).top;
      const posicaoY = topElemento - document.querySelector('.header').clientHeight - 50;

      if( window.scrollY >= posicaoY ) {
        const idTab = 'tab_' + tab.innerText;

       // console.log(tab.innerText + ' <-> ' + this.categoriaSelecionada);
        if( this.categoriaSelecionada !== tab.innerText ) {
         // console.log(tab.innerText);
          this.categoriaSelecionada = tab.innerText;

          this.posicioneTab('tab_' + tab.innerText);
        }
        break;
      }
    }
  }

  posicioneConteudo(categoria) {
    categoria = categoria.trim();
    const topElemento = this.getOffset(document.getElementById(categoria)).top;
    const y = topElemento - document.querySelector('.header').clientHeight - 20;

    this.estaFazendoScroll = true;

    let posicao = -1;

    const chequeScroll = () => {
      if( posicao !== window.scrollY ) {
        posicao = window.scrollY;

        setTimeout(chequeScroll, 100);
        return;
      }

      this.estaFazendoScroll = false;
    }

    setTimeout(chequeScroll, 100);

    window.scroll({
      top: y,
      behavior: 'smooth'
    });
  }

  mudeAba() {
  }

  exibirUnidade(produto: any) {
    return produto.tipoDeVenda && produto.tipoDeVenda === 'Peso'
  }

  private inicializePedido() {
    let pedido =  this.carrinhoService.obtenhaPedido();

    if(pedido.mesa && pedido.mesa.expirada){
      this.mesaExpirada = true;
    } else {
      this.pedido = pedido;
    }

    this.atualizeAvisoMesaAtiva();

    return Promise.resolve();
  }

  deveExibirAvisoMesaAtiva() {
    if(this.avisoMesaAtivaFechado || this.mesaExpirada)
      return false;

    if(!this.estaNoCardapioPrincipal())
      return false;

    return this.pedido && this.pedido.mesa && !this.pedido.expirou();
  }

  atualizeAvisoMesaAtiva() {
    this.exibirAvisoMesaAtiva = this.deveExibirAvisoMesaAtiva();
  }

  deveExibirAcaoSairDaMesa() {
    return this.pedido && (this.pedido.mesa || this.pedido.tokenCartaoPendente) &&
      !this.mesaExpirada && !this.pedido.expirou();
  }

  irParaDelivery() {
    if(this.pedido?.mesa)
      return this.abrirAvisoMesaAtiva();

    this.sairDaMesaParaDelivery();
  }

  abrirAvisoMesaAtiva() {
    this.avisoMesaAtivaFechado = false;
    this.exibirAvisoMesaAtiva = this.deveExibirAcaoSairDaMesa();
  }

  continuarNaMesaAtiva() {
    this.avisoMesaAtivaFechado = true;
    this.exibirAvisoMesaAtiva = false;

    const hash = this.pedido?.mesa?.hash;

    if(hash) {
      this.dominiosService.hashMesa = hash;
      this.router.navigateByUrl(this.obtenhaUrlCardapio('local/' + hash));
    }
  }

  sairDaMesaParaDelivery() {
    this.avisoMesaAtivaFechado = true;
    this.exibirAvisoMesaAtiva = false;
    this.hashMesa = null;
    this.dominiosService.hashMesa = null;
    this.dominiosService.codigoMesa = null;
    EstadoRodizioLoja.definaRodizio(null);
    this.pedido = this.carrinhoService.sairDaMesaParaDelivery();
    this.constantsService.limpeCacheCardapio();
    this.constantsService.recarregueEmpresa(false);
    this.router.navigateByUrl(this.dominiosService.obtenhaUrlHome());
  }

  obtenhaMinutosSessaoMesaAtiva() {
    if(!this.pedido?.timestamp)
      return 0;

    return Math.max(0, Math.floor((new Date().getTime() - this.pedido.timestamp) / 1000 / 60));
  }

  obtenhaHorarioValidadeMesaAtiva() {
    const timestamp = this.pedido?.timestamp || new Date().getTime();
    const validade = new Date(timestamp + (240 * 60 * 1000));
    const horas = String(validade.getHours()).padStart(2, '0');
    const minutos = String(validade.getMinutes()).padStart(2, '0');

    return horas + ':' + minutos;
  }

  private estaNoCardapioPrincipal() {
    const path = this.activatedRoute?.snapshot?.routeConfig?.path;

    return !path || path === '' || path === 'index';
  }

  private obtenhaUrlCardapio(caminho: string) {
    const raiz = this.dominiosService.obtenhaRaizCardapio();
    const partes = [raiz, caminho].filter((parte) => parte);

    return '/' + partes.join('/');
  }

  moverScrollDireita(scroll: HTMLDivElement, categoria: HTMLDivElement) {
    if( this.movendo ) return;

    const posicao = scroll.scrollLeft;

    let largura = categoria.clientWidth;

    if( this.isMobile ) {
      largura = this.larguraProdutos + 10;
    }

    const novaPosicao = posicao + largura;

    this.movendo = true;
    scroll.scroll({
      left: novaPosicao,
      behavior: 'smooth'
    });

    categoria.classList.add('moveu');

    setTimeout( () => {
      this.movendo = false;

      const scrollWidth = scroll.scrollWidth;
      if (scrollWidth - largura === novaPosicao) {
        categoria.classList.add('scroll_fim');
      }
    }, 500);
  }

  moverScrollEsquerda(scroll: HTMLDivElement, categoria: HTMLDivElement) {
    if( this.movendo ) return;

    categoria.classList.remove('scroll_fim');

    const posicao = scroll.scrollLeft;

    let largura = categoria.clientWidth;

    if( this.isMobile ) {
      largura = this.larguraProdutos + 10;
    }


    let novaPosicao = posicao - largura;
    if( novaPosicao < 0 ) {
      novaPosicao = 0;
    }

    this.movendo = true;
    scroll.scroll({
      left: novaPosicao,
      behavior: 'smooth'
    });

    setTimeout( () => {
      if( novaPosicao === 0 ) {
        categoria.classList.remove('moveu');
      }
      this.movendo = false;
    }, 500);
  }



  clicouBanner(indice: any) {
    const banner = this.banners[indice];

    if( banner.comando === 'LINK' ) {
      window.open(banner.extra);
    } else if( banner.comando === 'BUSCA' ) {
      const state = {state: {produtos: this.produtos,
          produtosPorCategoria: this.produtosPorCategoria, categorias: this.categorias}};

      this.router.navigateByUrl('/' + this.nomePagina + '/busca?q=' + banner.extra, {}).then( () => {

      });
    }
  }

  deveTerBordas() {
    return true;
  }

  fecheMenuCategorias() {
    this.sharedDataService.exibirMenuMobile = false;
    return false;
  }



  private setColunasMegaMenu() {

    for(let categoria of this.categoriasMegamenu){
       this.colunasMenu[categoria.id] = {
          coluna1: { total: 0, subcategorias: []},
          coluna2: { total: 0, subcategorias: []},
          coluna3: { total: 0, subcategorias: []}
      }

      for(let i = 0 ; i <  categoria.subcategorias.length; i++){
        let item: any = this.colunasMenu[categoria.id];

        let coluna: any = this.obtenhaMaisVazia(item.coluna1, item.coluna2, item.coluna3)
        let subcategoria = categoria.subcategorias[i];
        coluna.subcategorias.push(subcategoria)

        let total = 1 + subcategoria.subcategorias.length;

        coluna.total += total; //so exibi 8 itens da subcategoria na tela
      }
    }
  }

  private obtenhaMaisVazia(categoriasColuna1: any, categoriasColuna2: any, categoriasColuna3: any){
    if(categoriasColuna1.total <= categoriasColuna2.total &&  categoriasColuna1.total <= categoriasColuna3.total )
      return categoriasColuna1;

    if(categoriasColuna2.total <= categoriasColuna3.total)
      return categoriasColuna2;


    return categoriasColuna3;
  }


  getColunas(categoria: any): any{
    return this.colunasMenu[categoria.id];
  }

  deveExibirBannerTema() {
    return true;
  }

  scrollParaDireita() {

    let tamanhoTotal = 0;

    for(let i = 0; i <  this.wraper.nativeElement.firstChild.children.length; i++)
      tamanhoTotal += this.wraper.nativeElement.firstChild.children[i].offsetWidth;

    let maximoScroll = tamanhoTotal - this.wraper.nativeElement.offsetWidth

    if(this.deslocamento <= maximoScroll  ) {
      this.deslocamento += 200;
    }
  }

  scrollParaEsquerda(){
    this.deslocamento -= 200;
    if(this.deslocamento  < 0 )
      this.deslocamento  = 0;

  }

  marginLeft(){
    return String(`-${this.deslocamento}px`);
  }

  paddingLeft(){ //padding-left
    return String(`${this.deslocamento}px`);
  }

  solicitouFecharMesa() {
    this.solicitandoFechar = true;

    this.carrinhoService.soliciteFecharMesa().then((resultado: any) => {
      this.timerSolicitarFecharNovamente = 180;

      this.inicieTimerSolicitarFecharNovamente()


      this.mensagemSucessoGarcom = 'Foi solicitado fechar a conta.'

    })

  }


  solicitouGarcom() {
    this.solicitandoGarcom = true;

    this.carrinhoService.soliciteGarcom().then((resultado: any) => {
      this.timerSolicitarGarcomNovamente = 180;

      this.inicieTimerSolicitarGarcomNovamente()

      this.mensagemSucessoGarcom = 'Garçom solicitado com sucesso.'

    })

  }

  fecheMensagemSucessoGarcom() {
    this.mensagemSucessoGarcom = null;
  }

  private inicieTimerSolicitarGarcomNovamente() {
    setTimeout(() => {
        this.timerSolicitarGarcomNovamente--;

        if (this.timerSolicitarGarcomNovamente > 0)
          this.inicieTimerSolicitarGarcomNovamente();
        else
          this.solicitandoGarcom = false;
          },
      1000)
  }

  private inicieTimerSolicitarFecharNovamente() {
    setTimeout(() => {
        this.timerSolicitarFecharNovamente--;

        if (this.timerSolicitarFecharNovamente > 0)
          this.inicieTimerSolicitarFecharNovamente();
        else
          this.solicitandoFechar = false;
      },
      1000)
  }


  irParaLogin(){
    if(this.isMobile){
      const telafone: string  =   this.pedido && this.pedido.contato ?  this.pedido.contato.telefone : null;
      this.dominiosService.vaParaLogin(window.location.pathname, telafone)
    } else {
      PainelLoginComponent.abraComoPopup(this.router, this.location, this.activatedRoute,  this.dialogService, null, () => {
        this.setSaldoDisponivel();
      } );
    }

    return false;
  }

  irParaVerSaldo(){
    if(this.isMobile){
      this.dominiosService.vaParaValidarLogin(window.location.pathname, this.pedido.contato)
    } else {
      ValidarContatoZapComponent.abraComoPopup(this.router, this.location, this.activatedRoute,
        this.dialogService,  this.pedido.contato , (result) => {
          if(result && result.login) {
            this.setSaldoDisponivel();
          }
        });
    }

    return false;
  }
}
